export default {
	featureModeControls: {
		selectFeatureHint:
			"Selezionare un foro / un ritaglio nel modello per assegnare una lavorazione (filettatura, svasatura, incisione, ecc.).",
		differentTypesHint:
			"Più funzioni possono essere modificate insieme solo se sono dello stesso tipo (ad es. aggiungere una filettatura a più fori rotondi).",
		andCutting: " e taglio",
		settingsLabel: "Impostazioni:",
		pleaseSelectTool: "Selezionare...",
		pressJoinCategories: {
			all: "Tutti gli inserti pressati",
			nut: "Dado pressato",
			threadedStud: "Perno filettato pressato",
			threadedBushing: "Boccola filettata pressata",
		},
		noToolsForSide: "Per il lato selezionato non sono purtroppo disponibili utensili.",
		noToolsForMaterial: "Purtroppo questa lavorazione non è disponibile per questo materiale.",
		apply: "Applica",
	},
	featurePanel: {
		minimize: "minimizza",
		groups: {
			screwThread: "Filettature",
			countersink: "Svasature",
			extrudedThread: "Collari estrusi",
			cylinderHeadBoltHole: "Svasature per viti a testa cilindrica",
			pressJoin: "Inserti pressati",
			engraving: "Incisioni",
			hole: "Fori rotondi",
			cutout: "Ritagli",
			weldline: "Cordoni di saldatura",
			anchorFace: "Lati superiori",
			bottomFace: "Lati inferiori",
			sideFace: "Lati esterni",
		},
		weldlineStatus: {
			cleaned: "molato",
			uncleaned: "non molato",
		},
		labels: {
			engraving: "Incisione {id}",
			diameter: "Diametro: {value}mm",
			cutout: "Ritaglio {id}",
			weldline: "Cordone di saldatura {id}",
			anchorFace: "Lato superiore {id}",
			bottomFace: "Lato inferiore {id}",
			sideFace: "Lato esterno {id}",
			weldlineTitle: "ID {id} - {length} mm",
			weldlineCornerSingular: " + angolo",
			weldlineCornerPlural: " + angoli",
		},
		undetermined: "Non determinato",
	},
	structurePanel: {
		minimize: "minimizza",
	},
	articlePanel: {
		minimize: "minimizza",
		blexonNumber: "N. Blexon:",
		material: "Materiale:",
		dimensions: "LxLxA:",
		saveAndClose: "Salva e chiudi",
		underReview: "In verifica",
		sendToHelpdesk: "Invia all'helpdesk",
		additionalDesignation: {
			groundFoil: " / spazzolato / pellicola",
			foil: " / pellicola",
			ribbed: " / rigato",
		},
	},
};
